<template>
  <div>
    <router-view />
    <vueCanvasNest
      :config="{
        color: '127,63,255',
        opactty: 1,
        count: count,
      }"
      :el="'#bg'"
      id="bg"
    />
  </div>
</template>

<script>
  import vueCanvasNest from 'vue-canvas-nest'
  export default {
    components: { vueCanvasNest },
    data() {
      return {
        count: parseInt(
          (document.body.clientWidth * document.body.clientHeight) / 6000,
        ),
      }
    },
    mounted() {
      console.log('canvas nest line number:', this.count)
    },
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  #bg {
    width: 100vw;
    height: 100vh;
    max-width: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -99;
  }
</style>
